export async function get_server_version() {
    const response = await window.fetch(`${process.env.REACT_APP_API_URL}/api/debug/version`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    });
    return await response.json();
}